export default {"src":"/_next/static/media/checkbox.036ef325.svg","height":25,"width":24};